/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TextOverflowCharacterLimit } from './character-limit.story';
export { default as TextOverflowExpandCollapseButtons } from './expand-collapse-buttons.story';
export { default as TextOverflowLineClamp } from './line-clamp.story';
export { default as TextOverflowMixedContent } from './mixed-content.story';
export { default as TextOverflowWidthBasedTruncation } from './width-based-truncation.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import CharacterLimitSrcRaw from './character-limit.story?raw';
import ExpandCollapseButtonsSrcRaw from './expand-collapse-buttons.story?raw';
import LineClampSrcRaw from './line-clamp.story?raw';
import MixedContentSrcRaw from './mixed-content.story?raw';
import WidthBasedTruncationSrcRaw from './width-based-truncation.story?raw';

export const CharacterLimitSrc = removeLicenseHeader(CharacterLimitSrcRaw);

export const ExpandCollapseButtonsSrc = removeLicenseHeader(
  ExpandCollapseButtonsSrcRaw,
);

export const LineClampSrc = removeLicenseHeader(LineClampSrcRaw);

export const MixedContentSrc = removeLicenseHeader(MixedContentSrcRaw);

export const WidthBasedTruncationSrc = removeLicenseHeader(
  WidthBasedTruncationSrcRaw,
);
